
import Vue from 'vue'
import JcdcCard from '@/components/jcdc/JcdcCard.vue'

export default Vue.extend({
  name: 'JcdcGradientCardGroup',
  components: { JcdcCard },
  props: { items: { type: Array, required: true } },
  computed: {
    xsScreen(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    smScreen(): boolean {
      return this.$vuetify.breakpoint.smOnly
    },
  },
  methods: {
    textColor(i) {
      switch (i) {
        case 2:
          return 'primary--text text--darken-3'
        default:
          return 'white--text'
      }
    },
    backgroundColor(i) {
      switch (i) {
        case 0:
          return 'accent'
        case 1:
          return 'primary'
        case 2:
          return 'primary lighten-4'
        default:
          return ''
      }
    },
  },
})
